import { gql } from "@apollo/client";

export default gql`
  mutation deleteMeetingTranscriptsNewPageMutation($meetingId: Int!) {
    deleteMeetingTranscripts(meetingId: $meetingId) {
      meeting {
        id
        hasTranscript
        transcript {
          id
        }
      }
    }
  }
`;
